import useScreenWakePort from '@UI/Providers/PortsProvider/Hooks/ScreenWake/useScreenWakePort';
import * as React from 'react';

/**
 * Reflects whether the screen wake lock is actually held right now, through `useSyncExternalStore` —
 * never a one-off `isHeld()` read at render, which would freeze the "ÉCRAN MAINTENU ALLUMÉ" mention on
 * whatever was true at mount. The platform releases the lock on its own in the background, so only a
 * subscription keeps the mention honest.
 */
function useScreenWakeIndicator(): boolean {
	const screenWakePort = useScreenWakePort();

	const subscribe = React.useCallback(
		(onStoreChange: () => void): (() => void) => screenWakePort.subscribe(() => onStoreChange()),
		[screenWakePort],
	);

	const getSnapshot = React.useCallback((): boolean => screenWakePort.isHeld(), [screenWakePort]);

	return React.useSyncExternalStore(subscribe, getSnapshot);
}

export default useScreenWakeIndicator;
